export enum Week {
  SUNDAY = 0,
  MONDAY = 1,
  TUESDAY = 2,
  WEDNESDAY = 3,
  THURSDAY = 4,
  FRIDAY = 5,
  SATURDAY = 6
}
export const WeekTranslation = {
  [Week.SUNDAY]: 'enum.week.sunday',
  [Week.MONDAY]: 'enum.week.monday',
  [Week.TUESDAY]: 'enum.week.tuesday',
  [Week.WEDNESDAY]: 'enum.week.wednesday',
  [Week.THURSDAY]: 'enum.week.thursday',
  [Week.FRIDAY]: 'enum.week.friday',
  [Week.SATURDAY]: 'enum.week.saturday'
};
